module.exports = __webpack_public_path__ + "static/media/skill-sass.79e998a7.png";